import { createApp, Vue } from 'vue'
import App from './App.vue'
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn: "https://c77c2b9060a248d3a97b576b4eb52b07@o450101.ingest.sentry.io/5434243",
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
    }),
    new Integrations.BrowserTracing(),
  ],
  tracesSampleRate: 1,
});

createApp(App).mount('#app')
